<template>
  <div
    class="form-group"
    :class="[
    inputGroupClass,
    {
      'has-prefix': !!$slots.prefix,
      'has-suffix': !!$slots.suffix
    }
  ]"
  >
    <label
      class="form-label"
      for="text-input"
      :class="{ 'has-error ': error }"
      v-if='label'
    >
      {{ label  }}
    </label>
    <div class="form-group__panel">
      <span class="form-control__prefix" for="text-input">
        <slot name="prefix"></slot>
      </span>
      <input
        id="text-input"
        class="form-control"
        :class="[inputClasses, { 'has-error ': showError || error }]"
        :style="inputStyles"
        :type="type"
        v-on="inputListeners"
        v-bind="$attrs"
      />
      <span class="form-control__suffix">
        <slot name="suffix"></slot>
      </span>
    </div>
    <transition name="slide">
      <span v-show="error" class="form-feedback is-danger">{{ error }}</span>
    </transition>
  </div>
</template>

<script>
/* eslint-disable arrow-parens */
import themeSetupMixin from '@/mixins/theme';
import inputMixin from '../input.mixin';

export default {
  mixins: [themeSetupMixin, inputMixin],
  props: {
    type: {
      type: String,
      default: 'text',
      validator: value => ['text', 'email', 'password'].includes(value),
    },
    /**
     * Custom input validator
    */
    validator: {
      type: Function,
      default: null,
    },
    /**
     * if it is not empty, show error
    */
    error: String,
    /**
     * input label
    */
    label: String,
    /**
     * ClassNames for input group
    */
    inputGroupClass: {
      type: String,
      default: '',
    },
    /**
     * ClassNames for input
    */
    inputClasses: {
      type: String,
      default: '',
    },
    /**
     * Inline Styles for input
    */
    inputStyles: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showError: false,
      inputVal: '',
    };
  },
  watch: {
    inputVal: {
      /**
     * Execute specified validator
     * @param {Text} value
     * @return {null}
     */
      handler(value) {
        if (this.validator !== null) {
          this.showError = !this.validator(value);
        }
        return null;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
